<template>
  <v-card flat class="px-3">
    <v-col
      @click="beforeLeave"
      cols="12"
      class="body-bold-smaller btnTextType1--text py-0 backBtn"
    >
      <v-icon size="12" class="backIcon">mdi-arrow-left</v-icon>
      <a type="primary" class="body-bold-smaller brand-60-base--text"
        >{{ $t('message.actions.return') }}
      </a>
    </v-col>

    <v-col class="pt-1 py-0">
      <span class="body-bold-medium">{{
        $t('message.pages.video.saveProgress')
      }}</span>
    </v-col>

    <v-col cols="12" class="py-0">
      <span class="body-regular-smaller textType6--text pageDescription">
        {{ $t('message.pages.video.saveProgressMessage') }}
        <a target="_blank" type="secondary" :href="chapterArticle">
          <span>
            {{ $t('message.embedModal.knowMore') }}
          </span>
          <v-icon size="12">mdi-open-in-new</v-icon>
        </a>
      </span>
    </v-col>

    <v-col class="pt-6 py-0">
      <span class="body-bold-base">{{
        $t('message.pages.video.saveProgress')
      }}</span>
    </v-col>

    <v-row no-gutters class="py-0 px-3">
      <v-col cols="12" class="mt-2">
        <v-row>
          <v-col cols="6" class="d-flex align-center body-regular-small">
            <span>{{
              $t('message.pages.videoPlayerSaveProgress.activeSaveProgress')
            }}</span>
          </v-col>
          <v-col cols="6" class="d-flex align-center justify-end">
            <v-switch
              class="mt-0 pt-0 d-flex align-center"
              v-model="saveProgress"
              @click="changePlayer({ isToForce: true })"
              hide-details
              :disabled="!hasEditVideoPerm"
            ></v-switch>
          </v-col>

          <v-col class="pa-0" cols="12" v-if="saveProgress">
            <v-col cols="12" class="mb-3">
              <v-divider />
            </v-col>

            <v-col cols="12" class="py-0">
              <span class="body-bold-base">{{
                $t('message.pages.videoPlayerSaveProgress.config')
              }}</span>
            </v-col>

            <v-col class="d-flex pt-0">
              <v-col cols="10" class="pl-0">
                <p class="mb-0 body-regular-small">
                  {{
                    $t(
                      'message.pages.videoPlayerSaveProgress.showWarningScreen'
                    )
                  }}
                </p>
                <span class="body-regular-smaller textType6--text">{{
                  $t('message.pages.videoPlayerSaveProgress.chooseRestartVideo')
                }}</span>
              </v-col>
              <v-col cols="2" class="d-flex justify-end align-center pr-0">
                <v-tooltip bottom :disabled="saveProgress">
                  <template v-slot:activator="{ on }">
                    <div v-on="on" class="d-inline-block">
                      <v-switch
                        class="mt-0"
                        v-model="saveProgressScreen"
                        :disabled="!saveProgress || !hasEditVideoPerm"
                        @click="changePlayer"
                        hide-details
                      ></v-switch>
                    </div>
                  </template>
                  <span>{{
                    $t('message.pages.video.disabledSaveProgress')
                  }}</span>
                </v-tooltip>
              </v-col>
            </v-col>
          </v-col>
        </v-row>
      </v-col>

      <v-scroll-x-transition mode="out-in" hide-in-live>
        <v-form ref="form" v-model="isFormValid" lazy-validation class="mt-5">
          <v-row v-if="saveProgressScreen">
            <v-col class="d-flex pb-0 pt-0" cols="12">
              <v-col
                class="pa-0 body-regular-small align-center d-flex"
                cols="6"
              >
                {{ $t('message.pages.videoPlayerSaveProgress.title') }}</v-col
              >
              <v-col class="pa-0" cols="6">
                <v-input
                  v-model="saveProgressTitle"
                  :disabled="!hasEditVideoPerm"
                  outlined
                  hide-details
                  :rules="textfieldRules"
                  @blur="changePlayer"
                  color="primary"
                  dense
                >
                </v-input>
              </v-col>
            </v-col>
            <v-col class="d-flex pb-0 pt-4" cols="12">
              <v-col class="pa-0" cols="6">
                <p class="mb-0 body-regular-small">
                  {{ $t('message.pages.videoPlayerSaveProgress.playText') }}
                </p>
                <span class="body-regular-smaller textType6--text"
                  >{{
                    $t('message.pages.videoPlayerSaveProgress.continueVideo')
                  }}
                </span>
              </v-col>
              <v-input
                v-model="saveProgressButton1Title"
                :disabled="!hasEditVideoPerm"
                outlined
                hide-details
                :rules="textfieldRules"
                @blur="changePlayer"
                color="primary"
                dense
              >
              </v-input>
            </v-col>
            <v-col class="d-flex pb-0 pt-3" cols="12">
              <v-col class="pa-0" cols="6">
                <p class="mb-0 body-regular-small">
                  {{ $t('message.pages.videoPlayerSaveProgress.restartText') }}
                </p>
                <span class="body-regular-smaller textType6--text"
                  >{{
                    $t('message.pages.videoPlayerSaveProgress.restartVideo')
                  }}
                </span>
              </v-col>
              <v-input
                v-model="saveProgressButton2Title"
                outlined
                hide-details
                :disabled="!hasEditVideoPerm"
                :rules="textfieldRules"
                @blur="changePlayer"
                dense
              >
              </v-input>
            </v-col>
            <v-col cols="12" class="d-flex align-center pb-0">
              <v-col class="pa-0" cols="6">
                <p class="mb-0 body-regular-small">
                  {{
                    $t(
                      'message.pages.videoPlayerSaveProgress.backgroundOpacity'
                    )
                  }}
                </p>
                <span class="body-regular-smaller textType6--text"
                  >{{ $t('message.pages.videoPlayerSaveProgress.opacityText') }}
                </span>
              </v-col>
              <v-col class="pa-0 d-flex backgroundContainer" cols="6">
                <v-slider
                  class="pt-1"
                  v-model="saveProgressBackgroundOpacityFormated"
                  :disabled="!hasEditVideoPerm"
                  hide-details
                  thumb-color="primary"
                  :min="50"
                  @change="changePlayer"
                >
                  <template #prepend>
                    <div class="minmaxcontainer">
                      <p class="minmax">50</p>
                    </div>
                  </template>
                  <template #append>
                    <div class="minmaxcontainer">
                      <p class="minmax">100</p>
                    </div>
                  </template> </v-slider
                ><v-input
                  class="ml-2"
                  hide-details
                  @keydown="restrictToNumbers"
                  @input="validatePercentageInput"
                  @blur="validatePercentageInput"
                  @change="changePlayer"
                  style="max-width: 52px"
                  :maxlength="3"
                  v-model="saveProgressBackgroundOpacityFormated"
                >
                  <template v-slot:append>
                    <span class="appendPx">%</span>
                  </template>
                </v-input>
              </v-col>
            </v-col>
            <v-col class="d-flex justify-space-between align-center" cols="12">
              <v-col class="pa-0" cols="6">
                <p class="mb-0 body-regular-small">
                  {{
                    $t(
                      'message.pages.videoPlayerSaveProgress.backgroundColorAndFont'
                    )
                  }}
                </p>
                <span class="body-regular-smaller textType6--text"
                  >{{
                    $t(
                      'message.pages.videoPlayerSaveProgress.textBackgroundAndFont'
                    )
                  }}
                </span>
              </v-col>
              <base-btn size="small" @click="goToColors" type="tertiary">
                {{ $t('message.embedModal.domainBtn') }}
              </base-btn>
            </v-col>
          </v-row>
        </v-form>
      </v-scroll-x-transition>
    </v-row>

    <span
      v-if="internalError"
      class="red--text caption align-text ml-2 mt-2 d-block"
    >
      <v-icon color="red" size="16" class="mt-n1"> mdi-alert-circle </v-icon>
      {{ $t('message.pages.video.errors.addSaveProgress') }}
    </span>

    <portal to="actions-footer">
      <div class="d-flex flex-row actions-row" v-if="hasEditVideoPerm">
        <v-spacer></v-spacer>
        <v-tooltip max-width="184px" top :disabled="!withoutChanges">
          <template v-slot:activator="{ on, attrs }">
            <div class="pl-2" v-bind="attrs" v-on="on">
              <base-btn
                type="tertiary"
                class="mr-2 px-4"
                text
                :disabled="loadingButtonSave || withoutChanges"
                @click="handleUndoChanges"
              >
                {{ $t('message.cancel') }}
              </base-btn>
            </div>
          </template>
          <span>{{ $t('message.noChanges') }}</span>
        </v-tooltip>
        <v-tooltip max-width="184px" top :disabled="!withoutChanges">
          <template v-slot:activator="{ on, attrs }">
            <div class="pl-2" v-bind="attrs" v-on="on">
              <base-btn
                type="primary"
                class="px-6"
                :disabled="loadingButtonSave || withoutChanges"
                :loading="loadingButtonSave"
                @click="handleUpdateSaveProgress"
              >
                {{ $t('message.pages.video.publish') }}
              </base-btn>
            </div>
          </template>
          <span>{{ $t('message.noChanges') }}</span>
        </v-tooltip>
      </div>
    </portal>
    <unsaved-changes-modal />
  </v-card>
</template>

<script>
import UnsavedChangesModal from '../../../components/UnsavedChangesModal.vue'
import { mapActions, mapMutations, mapState } from 'vuex'
import i18n from '@/translations/lang'
import _ from 'lodash'

export default {
  name: 'VideoPlayerSaveProgress',
  components: {
    UnsavedChangesModal,
  },
  props: {
    handleBack: {
      type: Function,
      required: true,
    },
    handleSelectOption: {
      type: Function,
      required: true,
    },
    liveVideoId: {
      required: false,
    },
    hasEdit: {
      type: Array,
    },
  },
  data: () => ({
    videoId: '',
    loadingButtonSave: false,
    profileId: null,
    profileConfig: {},
    initialConfig: {},
    saveProgress: false,
    saveProgressScreen: false,
    saveProgressTitle: i18n.t(
      'message.pages.video.titleInputsResumePlay.titlePlaceholder'
    ),
    saveProgressBackgroundOpacity: 0,
    saveProgressBackgroundOpacityFormated: 0,
    saveProgressButton1Title: i18n.t(
      'message.pages.video.titleInputsResumePlay.playButtonPlaceholder'
    ),
    saveProgressButton2Title: i18n.t(
      'message.pages.video.titleInputsResumePlay.restartButtonPlaceholder'
    ),
    rules: {
      required: (v) => (v && !!v) || i18n.t('message.requiredField'),
      maxLength: (v) =>
        (v && v.length <= 50) || i18n.t('message.maximumLengthConfigs'),
      maxLengthTitle: (v) =>
        (v && v.length <= 100) || i18n.t('message.maximumLengthConfigTitle'),
      minLength: (v) => (v && v.length >= 3) || i18n.t('message.minimumLength'),
    },
    textfieldRules: [],
    withoutChanges: true,
    isFormValid: true,
  }),
  async mounted() {
    this.$root.$on('changeLanguage', this.updateText)
    this.videoId = this.liveVideoId ? this.liveVideoId : this.$route.params.id
    this.profileId = this.$store.state.video.video.config?.profile
    this.profileConfig = this.$store.state.video.profile?.saveProgress
    this.saveProgress =
      this.$store.state.video.profile?.saveProgress.saveProgress
    this.saveProgressScreen =
      this.$store.state.video.profile?.saveProgress.saveProgressScreen
    this.saveProgressTitle =
      this.$store.state.video.profile?.saveProgress.saveProgressTitle
    this.saveProgressBackgroundOpacity =
      this.$store.state.video.profile?.saveProgress.saveProgressBackgroundOpacity
    this.saveProgressButton1Title =
      this.$store.state.video.profile?.saveProgress.saveProgressButton1Title
    this.saveProgressButton2Title =
      this.$store.state.video.profile?.saveProgress.saveProgressButton2Title
    this.saveProgressBackgroundOpacityFormated =
      this.$store.state.video.profile?.saveProgress.saveProgressBackgroundOpacityFormated
    this.initialConfig = _.cloneDeep(
      this.$store.state.video.profile?.saveProgress
    )
    this.hasEdit.push(this.checkChanges)
    this.$root.$on('discardChanges', () => {
      this.handleUndoChanges()
      this.handleBack()
    })
    this.$root.$on('handleGoForwardSaveProgressChanges', () => {
      this.handleSelectOption('colors')
    })
    this.$nextTick(() => {
      const grid__settings = document.querySelector('.grid__settings')
      grid__settings.scrollTo({ top: 0 })
    })

    this.$nextTick(() => {
      setTimeout(() => {
        this.activePreview()
      }, 5000)
    })
  },
  beforeDestroy() {
    this.$root.$off('discardChanges')
    this.$root.$off('handleGoForwardSaveProgressChanges')
  },
  computed: {
    ...mapState({
      profile: (state) => state.video.profile,
      video: (state) => state.video.video,
      profile_id: (state) => state.video.profile_id,
      internalError: (state) => state.video.internalError,
    }),
    chapterArticle() {
      if (this.locale === 'en') {
        return 'https://help.pandavideo.com/en-us/article/how-to-save-video-progress-in-browser-144aqk8/'
      }
      if (this.locale === 'es') {
        return 'https://help.pandavideo.com/es/article/como-salvar-el-progreso-del-video-en-el-navegador-7spv11/'
      }
      return 'https://help.pandavideo.com/pt-br/article/como-salvar-o-progresso-do-video-no-navegador-99iowe/'
    },
    locale() {
      return this.$i18next.resolvedLanguage
    },
    hasEditVideoPerm() {
      return (
        this.$store.state.user.userPermissions?.includes('put-video') ?? false
      )
    },
  },
  watch: {
    saveProgressScreen: function () {
      if (!this.saveProgressScreen) {
        this.saveProgressTitle = _.cloneDeep(
          this.initialConfig.saveProgressTitle
        )
        this.saveProgressBackgroundOpacity = _.cloneDeep(
          this.initialConfig.saveProgressBackgroundOpacity
        )
        this.saveProgressBackgroundOpacityFormated = _.cloneDeep(
          this.initialConfig.saveProgressBackgroundOpacityFormated
        )
        this.saveProgressButton1Title = _.cloneDeep(
          this.initialConfig.saveProgressButton1Title
        )
        this.saveProgressButton2Title = _.cloneDeep(
          this.initialConfig.saveProgressButton2Title
        )
        this.changePlayer()
      }
    },
    locale: {
      handler() {
        this.updateText()
      },
      immediate: true,
    },
    '$store.state.video.profile': {
      handler() {
        this.withoutChanges = this.checkChanges()
      },
      deep: true,
    },
  },
  methods: {
    ...mapActions('video', [
      'updateProfile',

      'createProfile',

      'setProfileToVideos',
    ]),
    ...mapMutations('video', [
      'UPDATE_VIDEO_PROFILE',
      'UPDATE_VIDEO_PROFILE_ID',
      'UPDATE_STATUS_ERROR',
    ]),
    ...mapMutations('user', ['UPDATE_GLOBAL_SNACKBAR']),
    async validateForm() {
      this.textfieldRules = [
        this.rules.required,
        this.rules.maxLength,
        this.rules.minLength,
      ]
      await this.$refs.form.validate()
    },
    updateText() {
      this.saveProgressTitle = i18n.t(
        'message.pages.video.titleInputsResumePlay.titlePlaceholder'
      )
      this.saveProgressButton1Title = i18n.t(
        'message.pages.video.titleInputsResumePlay.playButtonPlaceholder'
      )
      this.saveProgressButton2Title = i18n.t(
        'message.pages.video.titleInputsResumePlay.restartButtonPlaceholder'
      )
      this.profile.saveProgressTitle = this.saveProgressTitle
      this.profile.saveProgressButton1Title = this.saveProgressButton1Title
      this.profile.saveProgressButton2Title = this.saveProgressButton2Title

      this.$nextTick(() => {
        this.changePlayer()
      })
    },
    async handleUpdateSaveProgress() {
      await this.validateForm()

      if (!this.isFormValid) return

      this.profile.saveProgress['saveProgressTitle'] = this.saveProgressTitle
      this.profile.saveProgress['saveProgressButton1Title'] =
        this.saveProgressButton1Title
      this.profile.saveProgress['saveProgressButton2Title'] =
        this.saveProgressButton2Title

      this.loadingButtonSave = true
      const saveProgress = {
        saveProgress: this.profile.saveProgress?.saveProgress
          ? this.profile.saveProgress?.saveProgress
          : false,
        saveProgressScreen: this.profile.saveProgress?.saveProgressScreen
          ? this.profile.saveProgress?.saveProgressScreen
          : false,
        saveProgressTitle: this.profile.saveProgress?.saveProgressTitle
          ? this.profile.saveProgress?.saveProgressTitle
          : '',
        saveProgressBackgroundOpacity:
          parseInt(
            this.profile.saveProgress?.saveProgressBackgroundOpacityFormated
          ) / 100,
        saveProgressButton1Title: this.profile.saveProgress
          ?.saveProgressButton1Title
          ? this.profile.saveProgress?.saveProgressButton1Title
          : '',
        saveProgressButton2Title: this.profile.saveProgress
          ?.saveProgressButton2Title
          ? this.profile.saveProgress?.saveProgressButton2Title
          : '',
      }
      if (
        this.saveProgressTitle.length < 3 ||
        this.saveProgressButton1Title.length < 3 ||
        this.saveProgressButton2Title.length < 3 ||
        this.saveProgressTitle.length > 100 ||
        this.saveProgressButton1Title.length > 30 ||
        this.saveProgressButton2Title.length > 30
      ) {
        this.loadingButtonSave = false
        return
      }
      if (!this.video.config.profile) {
        await this.createProfile(this.videoId)
        this.video.config.profile = this.profile_id
        this.profileId = this.profile_id
        await this.setProfileToVideos([this.profileId, this.videoId])
      }
      delete saveProgress.saveProgressBackgroundOpacityFormated
      const controls = this.$store.state.video.profile.controls
      const colors = this.$store.state.video.profile.colors
      try {
        await this.updateProfile([
          this.profileId,
          {
            saveProgress: saveProgress,
            controls: controls,
            colors: colors,
          },
        ])
        this.profile.saveProgress['saveProgressBackgroundOpacityFormated'] =
          this.profile.saveProgress?.saveProgressBackgroundOpacity * 100
        this.internalError
          ? ''
          : ((this.initialConfig = _.cloneDeep(this.profile.saveProgress)),
            this.handleSnackbar(this.$t('message.pages.video.changesSaved')),
            (this.withoutChanges = true))
        this.loadingButtonSave = false
      } catch (e) {
        console.error(e)
        this.loadingButtonSave = false
      }
      this.$root.$emit('updateEmbedPreviewChange')
    },
    goToColors() {
      if (!this.checkChanges()) {
        this.$root.$emit(
          'unsavedChangesModal',
          false,
          false,
          false,
          false,
          false,
          false,
          true
        )
      } else {
        this.handleSelectOption('colors')
      }
    },
    restrictToNumbers(event) {
      const allowedKeys = [
        '0',
        '1',
        '2',
        '3',
        '4',
        '5',
        '6',
        '7',
        '8',
        '9',
        'Backspace',
        'Tab',
        'ArrowLeft',
        'ArrowRight',
        'Delete',
      ]

      if (!allowedKeys.includes(event.key)) {
        event.preventDefault()
      }
    },
    validatePercentageInput(event) {
      if (!event || !event.target) {
        console.warn('Evento ou target indefinido no validatePercentageInput.')
        return
      }

      let value = parseInt(event.target.value.replace(/[^0-9]/g, ''), 10) || 0
      const min = 50
      const max = 100
      if (value < min) {
        value = min
      } else if (value > max) {
        value = max
      }
      this.saveProgressBackgroundOpacityFormated = value
      event.target.value = value
      this.changePlayer()
    },
    async activePreview() {
      console.log('activePreview')
      const iframe = document.getElementById('panda-player').contentWindow
      await iframe.postMessage(
        {
          type: 'currentTime',
          parameter: 1,
        },
        '*'
      )
      await iframe.postMessage(
        {
          type: 'currentTime',
          parameter: 0,
        },
        '*'
      )
    },
    changePlayer({ isToForce = false } = {}) {
      this.profile.saveProgress['saveProgress'] = this.saveProgress
      this.profile.saveProgress['saveProgressScreen'] = this.saveProgressScreen

      if (isToForce) {
        this.saveProgressScreen = this.saveProgress
        this.profile.saveProgress['saveProgressScreen'] = this.saveProgress
      }

      this.profile.saveProgress['saveProgressTitle'] = this.saveProgressTitle
      this.profile.saveProgress['saveProgressBackgroundOpacity'] =
        this.saveProgressBackgroundOpacity
      this.profile.saveProgress['saveProgressBackgroundOpacityFormated'] =
        this.saveProgressBackgroundOpacityFormated
      this.profile.saveProgress['saveProgressButton1Title'] =
        this.saveProgressButton1Title
      this.profile.saveProgress['saveProgressButton2Title'] =
        this.saveProgressButton2Title
      this.withoutChanges = this.checkChanges()
      this.UPDATE_STATUS_ERROR(false)
      this.UPDATE_VIDEO_PROFILE(this.profile)
      this.$root.$emit('updateEmbedPreviewChange')
    },
    handleUndoChanges() {
      this.saveProgress = _.cloneDeep(this.initialConfig.saveProgress)
      this.saveProgressScreen = _.cloneDeep(
        this.initialConfig.saveProgressScreen
      )
      this.saveProgressTitle = _.cloneDeep(this.initialConfig.saveProgressTitle)
      this.saveProgressBackgroundOpacity = _.cloneDeep(
        this.initialConfig.saveProgressBackgroundOpacity
      )
      this.saveProgressBackgroundOpacityFormated = _.cloneDeep(
        this.initialConfig.saveProgressBackgroundOpacityFormated
      )
      this.saveProgressButton1Title = _.cloneDeep(
        this.initialConfig.saveProgressButton1Title
      )
      this.saveProgressButton2Title = _.cloneDeep(
        this.initialConfig.saveProgressButton2Title
      )
      this.changePlayer()
    },
    checkChanges() {
      return _.isEqual(this.profile.saveProgress, this.initialConfig)
    },
    beforeLeave() {
      if (!this.checkChanges()) {
        this.$root.$emit('unsavedChangesModal')
      } else {
        this.UPDATE_STATUS_ERROR(false)
        this.handleBack()
      }
    },
    handleSnackbar(item) {
      if (!item) {
        item = i18n.t('message.changesSaved')
      }
      this.UPDATE_GLOBAL_SNACKBAR({
        open: true,
        text: item,
        type: 'success',
      })
    },
  },
}
</script>

<style scoped lang="scss">
.minmaxcontainer {
  margin-top: 3px;
  display: flex;
  color: varFigma(neutral-40-light) !important;

  i {
    color: varFigma(neutral-40-light) !important;
  }

  &.disabled {
    color: varFigma(neutral-70) !important;

    i {
      color: varFigma(neutral-70) !important;
    }
  }
}

::v-deep
  .backgroundContainer
  .v-text-field.v-text-field--enclosed:not(.v-text-field--rounded)
  > .v-input__control
  > .v-input__slot,
.backgroundContainer
  .v-text-field.v-text-field--enclosed
  .v-text-field__details {
  padding: 0 8px !important;
}

.minmax {
  text-align: right;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 150%;
  margin-bottom: 0 !important;
}

.appendPx {
  font-size: 12px;
  margin-top: 5px;
  color: varFigma(neutral-40-light);
}

::v-deep .v-slider--horizontal {
  min-height: 32px;
  margin-left: 0px !important;
  margin-right: 0px !important;
}
</style>

<style>
.range-slider-saveProgress .v-slider__thumb-label {
  height: 40px !important;
  width: 40px !important;
}
</style>
